//--- React
import { useMemo } from "react";
import { useSelector } from "react-redux";
//--- Ant Design
import { Col, Row, Tabs } from "antd";
import { HistoryOutlined } from "@ant-design/icons";
//--- Project
import dayjs from "dayjs";
import Routes from "./Routes";
import Overview from "./Overview";
import { getGrafanaBaseURL, getGrafanaInterval } from "components/Common/Utils";
import VehicleDetails from "components/Dashboard/VehicleDetails";
import { TEST_RIDE_SUMMARY } from "components/Common/Grafana/Constants";
import SpeedAnalytics from "./Analytics/Speed";
import BrakeAnalytics from "./Analytics/Brake";
import TurnsAnalytics from "./Analytics/Turns";
import TripStopAnalytics from "./Analytics/TripStops";
import AccelerationAnalytics from "./Analytics/Acceleration";
import NoData from "components/Common/NoData";

const RideAnalytics = ({ onChangeVehicle, vehicle, rearTyreDiameter }) => {
  const vehicleDetails = useSelector((state) => state.eol.vehicleDetails);
  const testRide = useSelector((state) => state.testRide);
  const tripSummary = testRide.tripSummary;

  const noData = !tripSummary?.tripDuration;
  const baseFilterObject = useMemo(() => {
    const userDetails = JSON.parse(localStorage.getItem("userDetails"));

    return {
      orgId: userDetails?.currentOrganisation?.grafanaOrganisationId,
      vehicle_id: vehicleDetails?.vehId,
      testid: tripSummary?.testId,
      interval: getGrafanaInterval(
        tripSummary?.testStartTime,
        tripSummary?.testEndTime
      ),
      from: tripSummary?.testStartTime,
      to: tripSummary?.testEndTime,
      rear_wheel_diameter: rearTyreDiameter,
    };
  }, [
    vehicleDetails?.vehId,
    tripSummary?.testId,
    tripSummary?.testStartTime,
    tripSummary?.testEndTime,
    rearTyreDiameter,
  ]);

  const items = [
    {
      key: "overview",
      label: "Overview",
      children: !noData ? (
        <Overview />
      ) : (
        <div className="no-test-ride-box">
          <NoData text="No test rides found" />
        </div>
      ),
    },
    {
      key: "routes",
      label: "Routes",
      disabled: noData,
      children: (
        <Routes
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
    {
      key: "brakes",
      label: "Brakes",
      className: "brakes-tab",
      disabled: noData,
      children: (
        <BrakeAnalytics
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
    {
      key: "turns",
      label: "Turns",
      className: "turns-tab",
      disabled: noData,
      children: (
        <TurnsAnalytics
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
    {
      key: "stops",
      label: "Stops",
      className: "stops-tab",
      disabled: noData,
      children: (
        <TripStopAnalytics
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
    {
      key: "acceleration",
      label: "Acceleration",
      className: "acceleration-tab",
      disabled: noData,
      children: (
        <AccelerationAnalytics
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
    {
      key: "dashboard",
      label: "Dashboard",
      className: "dashboard-tab",
      disabled: noData,
      children: (
        <SpeedAnalytics
          baseUrl={getGrafanaBaseURL(
            TEST_RIDE_SUMMARY.DASHBOARD_ID,
            TEST_RIDE_SUMMARY.DASHBOARD_NAME
          )}
          baseFilterObject={baseFilterObject}
        />
      ),
    },
  ];

  return (
    <Row
      gutter={[16, 16]}
      className="ride-analytics-page"
      data-testid="test-ride-statistic"
    >
      <Col span={24} className="title">
        Ride Analytics
      </Col>

      <Col span={24} className="mt05">
        <Row gutter={[16, 16]} justify={"space-between"}>
          <Col xs={24} sm={24} md={12} lg={10} xl={8} xxl={6} className="">
            <VehicleDetails
              onChangeImei={onChangeVehicle}
              imei={vehicle}
              card={false}
            />
          </Col>
          <Col>
            <div className="display-flex">
              {tripSummary?.testId && !noData ? (
                <div className="mobile-hide" data-testid={"test-ride-time"}>
                  #{tripSummary.testId}
                </div>
              ) : null}
              {tripSummary?.recordedTime && !noData ? (
                <div
                  className="mobile-hide ml05"
                  data-testid={"test-ride-time"}
                >
                  <HistoryOutlined className="mr05" />
                  {dayjs(tripSummary?.recordedTime).format(
                    "MMM DD YYYY, hh:mm A"
                  )}
                </div>
              ) : null}
            </div>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <Tabs items={items} className="analytic-tabs" />
      </Col>
    </Row>
  );
};

export default RideAnalytics;
